import { render } from "./App.vue?vue&type=template&id=0ec2342c"
const script = {}

import "./App.vue?vue&type=style&index=0&id=0ec2342c&lang=css"

import exportComponent from "/home/jason/.local/share/cdd/projects/default/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__